import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './theme.css';
import { initTheme } from './utils/theme';
import App from './App';

// Apply the persisted (or default) design theme before first paint.
initTheme();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
